// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3Q8bX","vLegacy":"SelectSecondary_vLegacy__bVvUE","error":"SelectSecondary_error__1Xhge","disabled":"SelectSecondary_disabled__2BOrh"};